<div class="date_picker" [ngClass]="isTop ? 'top_pos_dp' : 'bottom_pos_dp'">
    <div style="width: max-content;">
        <input class="form-control en" autocomplete="off" placeholder="yyyy-mm-dd" name="dp_{{htmlId}}"
            [(ngModel)]="model" ngbDatepicker #d="ngbDatepicker" [minDate]="minDate" [disabled]="isDisabled"
            [readOnly]="isReadOnly" (dateSelect)="onAction(1);" [placement]="isTop ? 'top' : 'bottom'"
            style="width: 115px;float: left;padding: 3px;margin-top: 3px;" />
        <button class="button_icon button_icon_color" style="top:3px" id="btn_date_picker_{{htmlId}}"
            [disabled]="isDisabled" (click)="onAction(1);d.toggle();" type="button">calendar_month</button>
        <button class="button_icon button_icon_color" *ngIf="isShowClearButton" style="top:3px"
            id="btn_date_clear_{{htmlId}}" (click)="onAction(4)" type="button">clear</button>
    </div>
    <div *ngIf="isOpen && months.length > 0" class="year_month">
        <div class="row">
            <div class="col-6">
                <ngx-select [optionValueField]="'key'" [optionTextField]="'value'" [items]="months"
                    [(ngModel)]="selectedMonth" [noAutoComplete]="true" (select)="onAction(2,selectedMonth)">
                </ngx-select>
            </div>
            <div class="col-6">
                <ngx-select [optionValueField]="'key'" [optionTextField]="'value'" [items]="years"
                    [(ngModel)]="selectedYear" [noAutoComplete]="true" (select)="onAction(3,selectedYear)">
                </ngx-select>
            </div>
        </div>
    </div>
</div>